const state = {
    filterBuildingType: [
      {name: 'Частный', value: 'SINGLE'},
      {name: 'Многоэтажный', value: 'MULTI'},
      {name: 'Коммунально-бытовое', value: 'COMMON'}
    ],
    filtersBuildingMaterial: [
      {name: 'Кирпич', value: 'BRIK', selected: false},
      {name: 'Бетон', value: 'CONCRETE', selected: false},
      {name: 'Железо бетон', value: 'IRON_CONCRETE', selected: false},
      {name: 'Асбоцементная труба', value: 'ASBEST_CEMENT_PIPE', selected: false},
      {name: 'Нержавеющая сталь', value: 'STAINLESS_STEEL', selected: false},
      {name: 'Нержавеущая сталь в кожухе из нержавеющей стали', value: 'STAINLESS_STEEL_IN_CASE_OF_STAINLESS_STEEL', selected: false},
      {name: 'Нержавеющая сталь в кожухе из оцинкованной стали', value: 'STAINLESS_STEEL_IN_CASE_OF_GALVANIZED_STEEL', selected: false},
      {name: 'Оцинкованнная сталь', value: 'GALVANIZED_STEEL', selected: false},
      {name: 'Оцинкованная сталь в кожухе из оцинкованной стали', value: 'GALVANIZED_STEELJ_IN_CASE_OF_STAINLESS_STEEL', selected: false},
      {name: 'Железо', value: 'IRON', selected: false},
      {name: 'Керамика', value: 'CERAMIC', selected: false},
      {name: 'Лицензированный пластик', value: 'LICENSED_PLASTIC', selected: false}
    ],
    filterStoveType: [
      {name: '2-х комфорочная', value: 'BURNER_2x'},
      {name: '3-х комфорочная', value: 'BURNER_3x'},
      {name: '4-х комфорочная', value: 'BURNER_4x'}
    ],
    filterBoilerType: [
      {name: 'Дымоходный', value: 'CHIMNEY'},
      {name: 'Турбированный', value: 'TURBO'},
      {name: 'Парапетный', value: 'PARAPET'},
      {name: 'Конвектор', value: 'CONVECTOR'},
      {name: 'Конденсационный', value: 'CONDENSING'}
    ],
    filterWaterHeaterType: [
      {name: 'Дымоходный', value: 'CHIMNEY'},
      {name: 'Турбированный', value: 'TURBO'}
    ],
    filterCheckupStatus: [
      {name: 'Пройдена', value: 'PASSED'},
      {name: 'Не пройдена', value: 'FAILED'},
      {name: 'Планируется', value: 'SCHEDULED'},
      {name: 'Ожидает проверки', value: 'VISIT_CONFIRMED'},
    ],
    filterStaffTypes: [
      {name: 'Администратор', value: 'ADMIN'},
      {name: 'Печник', value: 'PECHNIK'}
    ],
    filterLocationTypes: [
      {name: 'Улица', value: 'STREET'},
      {name: 'Переулок', value: 'LANE'},
      {name: 'Проспект', value: 'AVENUE'},
      {name: 'Аллея', value: 'ALLEY'},
      {name: 'Бульвар', value: 'BOULEVARD'},
      {name: 'Линия', value: 'LINE'},
      {name: 'Набережная', value: 'EMBANKMENT'},
      {name: 'Тракт', value: 'TRACKT'},
      {name: 'Тупик', value: 'DEAD_END'},
      {name: 'Шоссе', value: 'HIGHWAY'},
      {name: 'Участок', value: 'PIECE_OF_LAND'}
    ],
    filterSettlementsTypes: [
      {name: 'Город', value: 'CITY'},
      {name: 'Село', value: 'VILLAGE'},
      {name: 'пгт', value: 'URBAN_VILLAGE'}
    ],
    filtersCheckupStatus: [
      {name: 'Пройдена', value: 'PASSED'},
      {name: 'Не пройдена', value: 'FAILED'},
      {name: 'Планируется', value: 'SCHEDULED'},
      {name: 'Ожидает проверки', value: 'VISIT_CONFIRMED'}
    ],
    filtersRoles: [
      {name: 'Админ', value: 'ADMIN', key: '1'},
      {name: 'Печник', value: 'PECHNIK', key: '2'},
      {name: 'Собственник', value: 'USER', key: '3'}
    ],
    filtersUsers: [
      {name: 'активен', value: 'ACTIVE', key: '1'},
      {name: 'приостановлен', value: 'SUSPENDED', key: '2'},
      {name: 'заблокирован', value: 'BLOCKED', key: '3'},
      {name: 'верификация email', value: 'EMAIL_VERIFICATION', key: '4'}
    ]
};

const getters = {
    filtersBuildingMaterial: state => {
      return state.filtersBuildingMaterial
    },
    filterBuildingType: state => {
      return state.filterBuildingType
    },
    filterStoveType: state => {
      return state.filterStoveType
    },
    filterBoilerType: state => {
      return state.filterBoilerType
    },
    filterWaterHeaterType: state => {
      return state.filterWaterHeaterType
    },
    filterCheckupStatus: state => {
      return state.filterCheckupStatus
    },
    filterStaffTypes: state => {
      return state.filterStaffTypes
    },
    filterLocationTypes: state => {
      return state.filterLocationTypes
    },
    filterSettlementsTypes: state => {
      return state.filterSettlementsTypes
    },
    filtersCheckupStatus: state => {
      return state.filtersCheckupStatus
    },
    filtersRoles: state => {
      return state.filtersRoles
    }
};

const mutations = {
    filtersBuildingMaterial: (state, data) => {
      return state.filtersBuildingMaterial[data.index].selected = data.state
    },
    filterBuildingType: (state, payload) => {
      return state.filterBuildingType = payload
    },
    filterStoveType: (state, payload) => {
      return state.filterStoveType = payload
    },
    filterBoilerType: (state, payload) => {
      return state.filterBoilerType = payload
    },
    filterWaterHeaterType: (state, payload) => {
      return state.filterWaterHeaterType = payload
    },
    filterCheckupStatus: (state, payload) => {
      return state.filterCheckupStatus = payload
    },
    filtersCheckupStatus: (state, payload) => {
      return state.filtersCheckupStatus = payload
    },
    filtersRoles: (state, payload) => {
      return state.filtersRoles = payload
    }
};

const actions = {
  filtersBuildingMaterial({commit}, data) {
    commit('filtersBuildingMaterial', data)
  },
  filterBuildingType({commit}, data) {
    commit('filterBuildingType', data)
  },
  filterStoveType({commit}, data) {
    commit('filterStoveType', data)
  },
  filterBoilerType({commit}, data) {
    commit('filterBoilerType', data)
  },
  filterWaterHeaterType({commit}, data) {
    commit('filterWaterHeaterType', data)
  },
  filterCheckupStatus({commit}, data) {
    commit('filterCheckupStatus', data)
  },
  filtersCheckupStatus({commit}, data) {
    commit('filtersCheckupStatus', data)
  }
};

export default {
    state,
    getters,
    mutations,
    actions
}